import { request, type ApiResult } from '@/utils/request'
import type { AuthTokenVO } from './auth'

/**
 * 短信短链一次性免登 ticket 换发双令牌
 * POST /auth/sms-ticket
 * ticket 由短链 302 落地时携带（query: smslt），5 分钟内一次性有效
 */
export function exchangeSmsLoginTicket(
  ticket: string
): Promise<ApiResult<AuthTokenVO>> {
  return request.post<AuthTokenVO>('/auth/sms-ticket', { ticket })
}
